import {defineMessages} from 'react-intl';

export default defineMessages({
	popupButtonText: {
		id: 'productDetail.preorder.popup.button',
		defaultMessage: 'Info Pre-Order',
	}
});
